
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.bar-container {
  margin-top: 0.625rem;
  margin-bottom: 0.625rem;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  grid-template-rows: repeat(1, minmax(0, 1fr));
  color:var(--percentage-bar-black);
}

.graph-bar {
  pointer-events: none;
  z-index: 1;
  grid-column-start: 1;
  grid-row-start: 1;
  box-sizing: border-box;
  display: flex;
  height: 35px;
  border-radius: 60px;
  background-color:var(--percentage-bar-cyan);
}

.graph-data {
  position: relative;
  grid-column-start: 1;
  grid-row-start: 1;
  box-sizing: border-box;
  display: flex;
  height: 35px;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  gap: 0.625rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
  font-weight: var(--fw-semibold);
  text-transform: uppercase;
}

.graph-data .graph-detail {
  display: none;
}

.graph-data:hover .graph-detail {
  position: absolute;
}

.graph-data:hover .graph-detail {
  top: 0px;
}

.graph-data:hover .graph-detail {
  z-index: 30;
}

.graph-data:hover .graph-detail {
  display: block;
}

.graph-data:hover .graph-detail ul {
  display: flex;
}

.graph-data:hover .graph-detail ul {
  flex-direction: column;
}

.graph-data:hover .graph-detail ul {
  gap: 0.25rem;
}

.graph-data:hover .graph-detail ul {
  background-color: var(--gray-professional-lighten-4);
}

.graph-data:hover .graph-detail ul {
  font-weight: var(--fw-extralight);
}

.graph-data:hover .graph-detail ul {
  text-transform: capitalize;
}

.graph-data:hover .graph-detail ul{
        list-style:none;
        width:-moz-max-content;
        width:max-content;
        padding:0.5rem 1rem;
      }

.graph-data:hover .graph-detail ul span {
  display: flex;
}

.graph-data:hover .graph-detail ul span {
  align-items: center;
}

.graph-data:hover .graph-detail ul span {
  gap: 0.5rem;
}

.graph-data:hover .graph-detail ul span .icon {
  position: relative;
}

.graph-data:hover .graph-detail ul span .icon {
  height: 1rem;
}

.graph-data:hover .graph-detail ul span .icon {
  width: 1rem;
}

.graph-data:hover .graph-detail ul span .icon {
  border-radius: 9999px;
}

.graph-data:hover .graph-detail ul span .icon {
  background-color: var(--green-quality-darken-2);
}

.graph-data:hover .graph-detail ul span .icon::after {
  position: absolute;
}

.graph-data:hover .graph-detail ul span .icon::after {
  top: 5px;
}

.graph-data:hover .graph-detail ul span .icon::after {
  left: 5px;
}

.graph-data:hover .graph-detail ul span .icon::after {
  height: 6px;
}

.graph-data:hover .graph-detail ul span .icon::after {
  width: 6px;
}

.graph-data:hover .graph-detail ul span .icon::after {
  border-radius: 9999px;
}

.graph-data:hover .graph-detail ul span .icon::after {
  background-color: var(--neutral-white);
}

.graph-data:hover .graph-detail ul span .icon::after {
  --tw-content: "";
  content: var(--tw-content);
}

.graph-label {
  z-index: 10;
}

.graph-value {
  z-index: 20;
}

.graph-progress ul {
  position: absolute;
}

.graph-progress ul {
  bottom: 0px;
}

.graph-progress ul {
  top: 0px;
}

.graph-progress ul {
  bottom: -2.5rem;
}

.graph-progress ul {
  left: -0.5rem;
}

.graph-progress ul {
  right: -1rem;
}

.graph-progress ul {
  z-index: -1;
}

.graph-progress ul {
  display: flex;
}

.graph-progress ul {
  list-style-type: none;
}

.graph-progress ul {
  justify-content: space-between;
}

.graph-progress ul {
  padding: 0px;
}

.graph-progress ul {
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
}

.graph-progress ul {
  color: var(--gray-professional-lighten-2);
}

.graph-progress ul li {
  position: relative;
}

.graph-progress ul li {
  display: flex;
}

.graph-progress ul li {
  height: 100%;
}

.graph-progress ul li {
  align-items: flex-end;
}

.graph-progress ul li::before {
  position: absolute;
}

.graph-progress ul li::before {
  top: 2.5rem;
}

.graph-progress ul li::before {
  bottom: 1.5rem;
}

.graph-progress ul li::before {
  left: 50%;
}

.graph-progress ul li::before {
  z-index: 0;
}

.graph-progress ul li::before {
  width: 1px;
}

.graph-progress ul li::before {
  background-color: var(--gray-professional-lighten-2);
}

.graph-progress ul li::before {
  --tw-content: "";
  content: var(--tw-content);
}

:host([overlap]) .bar-container {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}

:host([overlap]) .bar-container{
    grid-template-columns:2fr 25px 2fr;
  }

@media (min-width: 480px){
    :host([overlap]) .bar-container{
      grid-template-columns:2fr 25px 3fr;
    }
  }

@media (min-width: 768px){
    :host([overlap]) .bar-container{
      grid-template-columns:1fr 25px 3fr;
    }
  }

:host([overlap]) .graph-bar {
  z-index: 20;
}

:host([overlap]) .graph-bar {
  grid-row-start: 1;
}

:host([overlap]) .graph-bar {
  height: 61px;
}

:host([overlap]) .graph-bar{
    grid-column:2 / -1;
  }

:host([overlap]) .graph-data {
  z-index: 20;
}

:host([overlap]) .graph-data {
  grid-row-start: 1;
}

:host([overlap]) .graph-data {
  height: 61px;
}

:host([overlap]) .graph-data{
    grid-column:2 / -1;
  }

:host([overlap]) .graph-description {
  z-index: 10;
}

:host([overlap]) .graph-description {
  grid-row-start: 1;
}

:host([overlap]) .graph-description {
  box-sizing: border-box;
}

:host([overlap]) .graph-description {
  display: flex;
}

:host([overlap]) .graph-description {
  height: 61px;
}

:host([overlap]) .graph-description {
  align-items: center;
}

:host([overlap]) .graph-description {
  justify-content: space-between;
}

:host([overlap]) .graph-description{
    grid-column:1 / span 2;
    border-top-left-radius:60px;
    border-bottom-left-radius:60px;
    background-color:var(--percentage-bar-gray);
  }

:host([overlap]) .graph-description p {
  margin: 0px;
}

:host([overlap]) .graph-description p {
  width: 90%;
}

:host([overlap]) .graph-description p {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

:host([overlap]) .graph-description p {
  font-weight: var(--fw-bold);
}

@media (min-width: 640px) {

  :host([overlap]) .graph-description p {
    width: 80%;
  }
}

@media (min-width: 640px) {

  :host([overlap]) .graph-description p {
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
  }
}

@media (min-width: 640px) {

  :host([overlap]) .graph-description p {
    font-weight: var(--fw-semibold);
  }
}

:host([overlap]) .graph-description p{
      font-size:13px;
      text-wrap:wrap;
      word-break:break-word;
      -webkit-hyphens:auto;
              hyphens:auto;
    }

@media (min-width: 768px){
      :host([overlap]) .graph-description p{
       font-size:14px;
      }
    }

:host([two-rows]) .bar-container {
  margin-top: 0px;
  margin-bottom: 0px;
}

:host([two-rows]) .bar-container {
  grid-template-rows: repeat(2, minmax(0, 1fr));
}

:host([two-rows]) .graph-bar {
  z-index: 20;
}

:host([two-rows]) .graph-bar {
  height: 35px;
}

:host([two-rows]) .graph-bar {
  max-height: 35px;
}

:host([two-rows]) .graph-bar{
    grid-column:1;
    grid-row:2;
  }

:host([two-rows]) .graph-data {
  height: 35px;
}

:host([two-rows]) .graph-data {
  max-height: 35px;
}

:host([two-rows]) .graph-data{
    grid-column:1;
    grid-row:2;
  }

:host([two-rows]) .graph-description {
  z-index: 10;
}

:host([two-rows]) .graph-description {
  grid-row-start: 2;
}

:host([two-rows]) .graph-description {
  box-sizing: border-box;
}

:host([two-rows]) .graph-description {
  display: flex;
}

:host([two-rows]) .graph-description {
  height: auto;
}

:host([two-rows]) .graph-description {
  align-items: center;
}

:host([two-rows]) .graph-description {
  justify-content: space-between;
}

:host([two-rows]) .graph-description{
    grid-column:1;
    grid-row:1;
  }

:host([two-rows]) .graph-description p {
  margin: 0px;
}

:host([two-rows]) .graph-description p {
  align-self: flex-end;
}

:host([two-rows]) .graph-description p {
  padding-bottom: 0.375rem;
}

:host([two-rows]) .graph-description p {
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
}

:host([two-rows]) .graph-description p {
  font-weight: var(--fw-semibold);
}

:host([with-shadow]) .bar-container {
  margin-top: 0.625rem;
  margin-bottom: 0.625rem;
}

:host([with-shadow]) .graph-bar {
  z-index: 29;
}

:host([with-shadow]) .graph-bar {
  height: 3rem;
}

:host([with-shadow]) .graph-data {
  height: 3rem;
}

:host([with-shadow]) .graph-data {
  border-radius: 60px;
}

:host([with-shadow]) .graph-data {
  background-color: var(--cyan-near-lighten-4);
}

:host([with-shadow]) .graph-label {
  position: relative;
}

:host([with-shadow]) .graph-label {
  z-index: 30;
}

:host([with-shadow]) .graph-label {
  line-height: 1rem;
}

:host([with-shadow]) .graph-value {
  position: relative;
}

:host([with-shadow]) .graph-value {
  z-index: 30;
}

:host([with-shadow]) .graph-value {
  line-height: 1rem;
}

:host([with-shadow]) .graph-description {
  display: none;
}

:host([show-description]) .graph-description {
  display: block;
}
`;